<div *ngIf="loading$ | async" class="loading-overlay">
    <div class="spinner"></div>
  </div>
